import { useEffect, useState } from 'react';
import RoleListEdit from './RoleListEdit';
import Pagination from '../common/Pagination';
import { toast } from 'react-toastify';
import { useDispatch } from 'react-redux';
import ConfirmPopUp from '../common/ConfirmPopUp';
import { getRoleListing } from '../store/slices/RoleUser';
import FullPageLoader from "../common/FullPageLoader";
import AddRolePopup from './AddRolePopup';
import { ROLE_FEATURES } from '../../src/config/constant';
import { useLanguage } from "../../src/context/LanguageContext";
import DynamicTable from '../component/table/DynamicTable';
import { tables } from '../config/switch';

function RoleListTable(props: any) {
    const dispatch: any = useDispatch();
    let [roleMappingList, setRoleMappingList] = useState<any>([]);
    let [featureList, setFeatureList] = useState<[]>([]);
    let [userList, setUserList] = useState<[]>([]);
    const [paginationData, setPaginationData] = useState<any>({});
    const [showPopup, ShowPopup] = useState(false);
    const [editRoleData, setEditRoleData] = useState({});
    const [showConfirmation, setShowConfirmation] = useState(false);
    const [idToDelete, setIdToDelete] = useState(0);
    const [loading, setLoading] = useState(false);
    const [showAddRole, setShowAddRole] = useState(false);
    const [trigger,setTrigger] = useState(0);
    const {translations} = useLanguage();

    const showEditPopUp = (action: boolean, data: any) => {
        ShowPopup(action);
        action ? setEditRoleData(data) : setEditRoleData({});            // set data for edit role popup.
        document.body.classList.remove("overflow-hidden");

        if (action) {
            document.body.classList.add("overflow-hidden");
        }
    }

    const getRoleListDetails = async (params: any) => {
        let filters = {
            page_number: params?.page_number ?? 1
        }
        //setLoading(true);
        dispatch(getRoleListing.getRoleData(filters)).then((res: any) => {
            if (res && res.status === 200) {
                setPaginationData({ ...res?.pagination });
                setRoleMappingList([...res?.data]);
            }
            setLoading(false);
        }).catch((err: Error) => {
            setLoading(false);
        })
    };

    const getFeatureListDetails = async (params?: { page_number: number }) => {
        let filters = {
            page_number: params?.page_number ?? 1
        }
       // setLoading(true);
        dispatch(getRoleListing.getFeaturesData(filters)).then((res: any) => {
            if (res && res.status === 200) {
                setFeatureList(res.data);
            }
            setLoading(false);
        }).catch((err: Error) => {
            setLoading(false);
        })
    };

    const getUserListDetails = async (params?: { page_number: number }) => {
        let filters = {
            page_number: params?.page_number ?? 1
        }
        setLoading(true);
        dispatch(getRoleListing.getAllUserListData(filters)).then((res: any) => {
            if (res && res.status === 200) {
                setUserList(res.data);

            }
            setLoading(false);
        }).catch((err: Error) => {
            setLoading(false);
        })
    };


    const showDeletePopUp = async (action: boolean, id: any) => {
        setIdToDelete(id);
        setShowConfirmation(true);
    }

    const confirmYes = async () => {
        dispatch(getRoleListing.updateStatus({ id: idToDelete, is_delete: 1 })).then((res: any) => {
            if (res && res.status === 200) {
                toast.success(res.message)
                getRoleListDetails({});
            }
        });
        confirmNo();
    };

    const confirmNo = () => {
        setShowConfirmation(false);
    };


    const runPaginationFunc = () => { };
    const handleRequestData = (params: any) => {
        let apiParams = {
            page_number: params.page_no
        }
        getRoleListDetails(apiParams);
    }

    const addNewRole = (action: boolean) => {
        setShowAddRole(action);
        document.body.classList.remove("overflow-hidden");

        if (action) {
            document.body.classList.add("overflow-hidden");
        }
    }

    const getApiData = async () => {
        await getRoleListDetails({});
        await getFeatureListDetails();
        
    }

    useEffect(() => {
        getApiData();
        // eslint-disable-next-line
    }, []);

    useEffect(()=>{
        getUserListDetails();
     // eslint-disable-next-line
    },[trigger]);

    return (
        <>
            <FullPageLoader show={loading} />
            {/* {
                HELPER.isUserHasAccessPage({permissionID: ROLE_FEATURES['task_role_assignment'], accessType: 'edit'}) && */}
                <div className="add-role-btn">
                            <button className="btn-line" onClick={() => addNewRole(true)}>
                                <span>{translations.RuleEngine?.['Add_Role'] || translations.commonMsg?.loading}</span>
                            </button>
                </div>
            {/* } */}

            
                <div className="data-table lead-list-table">
                    <DynamicTable
                        columns={tables.getRoleTable(translations)}
                        data={roleMappingList}
                        translations={translations}
                        showEditPopUp={showEditPopUp}
                        showDeletePopUp={showDeletePopUp}
                        roleFeatures={ROLE_FEATURES}
                    />
                    {(paginationData && paginationData['total'] > 10) && <Pagination paginateData={{
                        page: 1,
                        runPaginationFunc,
                        loading: false,
                        tableData: paginationData['limit'],
                        totalLengthWithoutPagination: paginationData['total'],
                        paginationData,
                        filteredData: {}
                    }}
                        sendRequestDataToParent={handleRequestData} />}

                    {showConfirmation === false ? ("") : (
                        <ConfirmPopUp
                            confirmNo={confirmNo}
                            confirmYes={confirmYes}
                            message={translations.RuleEngine?.['Delete_Role_Msg'] || translations.commonMsg?.loading} />
                    )}
                    {showPopup && <RoleListEdit
                        setLoading={setLoading}
                        showPopup={showPopup}
                        editRoleData={editRoleData}
                        featureList={featureList}
                        roleUserList={userList}
                        getRoleListDetails={(e: any) => getRoleListDetails(e)}
                        showEditPopUp={(e: boolean, data: any) => {
                            showEditPopUp(e, data);
                        }} 
                        setTrigger = {setTrigger}
                        trigger = {trigger}
                        />}
                    {showAddRole && <AddRolePopup
                        showAddRole={showAddRole}
                        getRoleListDetails={(e: any) => getRoleListDetails(e)}
                        addNewRole={(e: boolean) => {
                            addNewRole(e);
                        }} />}

                </div>

        </>

    )
}

export default RoleListTable

